import { useLocation } from "react-router-dom";

import { getPathLanguage } from "@/lib/i18n";
import { translateText } from "@/lib/translations";

const WHATSAPP_URL = "https://wa.me/34680330586";

export default function WhatsAppContact() {
  const location = useLocation();
  const label = translateText(
    "Questions? Chat with us",
    getPathLanguage(location.pathname)
  );

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-[0_8px_24px_rgba(15,23,42,0.24)] transition duration-200 hover:-translate-y-0.5 hover:bg-[#20bd5a] hover:shadow-[0_10px_28px_rgba(15,23,42,0.3)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/40 focus-visible:ring-offset-2 sm:bottom-6 sm:right-6"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 32 32"
        className="h-6 w-6 shrink-0 fill-current"
      >
        <path d="M16.04 2.67A13.2 13.2 0 0 0 4.6 22.46L2.73 29.3l7-1.84a13.18 13.18 0 1 0 6.31-24.79Zm0 23.77c-2.04 0-4.04-.55-5.78-1.59l-.42-.25-4.15 1.09 1.11-4.04-.27-.42a10.58 10.58 0 1 1 9.51 5.21Zm5.8-7.92c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.31-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.58a9.57 9.57 0 0 1-1.77-2.2c-.19-.32-.02-.49.14-.65.14-.14.32-.37.47-.55.16-.19.21-.32.32-.53.1-.21.05-.39-.03-.55-.08-.16-.71-1.71-.98-2.35-.25-.62-.51-.53-.71-.54h-.61c-.21 0-.55.08-.84.39-.29.32-1.11 1.08-1.11 2.64s1.14 3.07 1.29 3.28c.16.21 2.24 3.42 5.42 4.8.76.32 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.37.19-1.51-.08-.13-.29-.21-.61-.37Z" />
      </svg>
      <span>{label}</span>
    </a>
  );
}
